var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullRedShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 42,
    viewBox: "0 0 29 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4878 0L0 6.43902V18.2439C0 29.1902 7.61951 39.3854 14.4878 41.7463C21.3561 39.3854 28.9756 29.1902 28.9756 18.2439V6.43902L14.4878 0Z",
    fill: "#DB2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0928 10.7326H15.883V23.6106H13.0928V10.7326ZM13.0928 26.8301H15.883V29.835H13.0928V26.8301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullRedShield);
export default __webpack_public_path__ + "static/media/FullRedShield.5e261ec383c9a9cc84fd6b2648c3a449.svg";
export { ForwardRef as ReactComponent };